import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import TechStack from "./components/TechStack";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import About from "./components/About";
import Projects from "./components/Projects";
import Certificates from "./components/Certificates";

import "./App.css";

const App = () => {
  const theme = useSelector((state) => state.theme);
  const backgroundClass =
    theme === "LIGHT" ? "background-light" : "background-dark";
  return (
    <div className={`main-container ${backgroundClass}`}>
      <header className="background-top"></header>
      <div className="responsive-container">
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/work" element={<Projects />} />
          <Route exact path="/techstack" element={<TechStack />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/certificates" element={<Certificates />} />
        </Routes>
        <Footer />
      </div>
      <footer className="background-bottom"></footer>
    </div>
  );
};

export default App;
